import { isTouchDevice } from '@/scripts/utils';
import eventHub from '@/scripts/eventHub';
import MouseManger from './mouse';
import TouchManger from './touch';
import vars from '../vars';

class InteractionManager {
  constructor(DOMElement) {
    this.DOMElement = DOMElement;
    this.DOMRect = null;
    this.manager = null;
    this.point = { x: vars.layout.PLAYER_START_X, y: 0 };

    this.action = () => {};

    this.resize();

    this.resizeHandler = () => { this.resize(); };
    eventHub.$on('window-resize', this.resizeHandler);

    if (isTouchDevice()) {
      this.manager = new TouchManger(this);
    } else {
      this.manager = new MouseManger(this);
    }
  }

  resize() {
    this.DOMRect = this.DOMElement.getBoundingClientRect();
  }

  start() {
    this.manager.addEvents();
  }

  stop() {
    this.manager.removeEvents();
  }

  destroy() {
    eventHub.$off('window-resize', this.resizeHandler);
    this.manager = null;
  }
}

export default InteractionManager;
